export default "__VITE_ASSET__DyH90V7z__"